export default __webpack_public_path__ + "static/media/image_investors.a038d580.jpg";